import { render, staticRenderFns } from "./ZInputRut.vue?vue&type=template&id=fef3c8a4&"
import script from "./ZInputRut.vue?vue&type=script&lang=js&"
export * from "./ZInputRut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports